import { Search } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/ui/components/ui/popover";
import { ListItem } from "@/ui/components/shared/ListItem";
import { useStore } from "@/state/legacy_module_api";

interface ContactsNavPopoverProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const ContactsNavPopover = ({ open, onOpenChange }: ContactsNavPopoverProps) => {
  const setUsersTabShowSearch = useStore((s) => s.setUsersTabShowSearch);

  const handleSearchClick = () => {
    setUsersTabShowSearch(true);
    onOpenChange?.(false);
  };

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger className="hidden" />
      <PopoverContent className="w-56 p-0" align="end">
        <div onClick={handleSearchClick} className="cursor-pointer">
          <ListItem
            icon={<Search className="w-5 h-5" />}
            title="Search User"
            showChevron
          />
        </div>
      </PopoverContent>
    </Popover>
  );
};
